export interface IIterationEffort {

    /**
     * Iteration ID
     */
    iterationId: string;

    /**
     * Count of work items by type
     */
    countByWorkItemType: IDictionaryStringTo<number>;

    /**
     * Cumulative efforts for all work items
     */
    totalEfforts: number;

    /**
     * Details of all work items
     */
    workItemsById: IDictionaryNumberTo<IPlanningWorkItem>;
}

export interface IPlanningWorkItem {
    id: number;
    iterationPath: string;
    effort: number;
    state: string;
    workItemType: string;
}
